import React from "react";
import { HomeIcon, PawPrintIcon, RefreshCwIcon, TreesIcon, WrenchIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { categories } from "../data/content";
const icons: Record<string, typeof HomeIcon> = {
  home: HomeIcon,
  workshop: WrenchIcon,
  outdoor: TreesIcon,
  twoInOne: RefreshCwIcon,
  pets: PawPrintIcon
};
export function ProjectCategories() {
  return <section className="bg-white px-4 py-16" aria-labelledby="categories-title" data-id="element-225" data-mp="1ig06a4x7f96n">
      <div className="mx-auto max-w-6xl" data-id="element-226" data-mp="1ndtdn1a8u98i">
        <SectionHeading id="categories-title" title="Not just classic projects" accent="Endless possibilities" intro="WOODWORKING READY™ isn't limited to one type of woodworking. You'll find projects for:" data-id="element-227" data-mp="1scd3hcryk565" />
        <ul className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-5" data-id="element-228" data-mp="zn63e9cuv7is">
          {categories.map(c => {
          const Icon = icons[c.icon];
          return <li key={c.title} className="border-t-2 border-brand pt-5" data-id="element-229" data-mp="y77k3ry8lp18">
                <Icon className="h-6 w-6 text-brand" aria-hidden="true" data-id="element-230" data-mp="t84pz2jsp381" />
                <h3 className="mt-3 font-heading font-bold uppercase" data-id="element-231" data-mp="t9xvufml3jez">{c.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-232" data-mp="ofbl8eobtuvy">{c.text}</p>
              </li>;
        })}
        </ul>
        <div className="mt-12 text-center font-heading text-lg font-bold" data-id="element-233" data-mp="fg6ondwbsbmf">
          <p data-id="element-234" data-mp="fe3nbxpq2w2e">Build something useful.</p>
          <p data-id="element-235" data-mp="ah3refml79p0">Build something smart.</p>
          <p className="text-brand" data-id="element-236" data-mp="ag2339gk8qpc">Build something you'll actually use.</p>
        </div>
        <div className="mt-8" data-id="element-237" data-mp="5ishk4wakz6s">
          <CtaButton label="Download now" data-id="element-238" data-mp="5k3js0a39yvs" />
        </div>
      </div>
    </section>;
}